export const getRefinementCrumbs = () => `{
  displayName
  dimensionName
  label
  multiSelect
  properties {
    navigationState
    nValue
  }
  ancestors {
    label
    navigationState
    properties {
      navigationState
      nValue
    }
  }
}`;

export const getReviews = () => `{
  count
  bvId
  averageOverallRating
}`;

export const getAllInseam = () => `{
  productId
  productUrl
  inseam
}`;

export const getProductAttributes = () => `{
  productContentCare {
    colorId
    heroBannerHotSpotText
    care {
      careId
      careDescription
      iconImgUrl
    }
  }
  productContentFeature {
    f5ContentAlignmentPDP
    styleId
    f5Features {
      featureName
      featureDescription
    }
  }
  productContentFabric {
    fabricDescription
    fabricDisplayName
    fabricId
    fabricPurposes
  }
  productContentWhyWeMadeThis
}`;

export const getColorAttributes = () => {
  const sectionSchema = `
    {
      media {
        captionText
        imageAlt
        videoSrcPortrait
        videoPosterSrc
        videoPosterSrcPortrait
        imageSrc
        videoSrc
      }
      title
      attributes {
        iconId
        list
        text
        attributeType
      }
    }
  `;

  return `
    {
      colorId
      styleColorId
      wwmt
      fabricPill
      colorGroups
      designedFor {
        activityText
        iconId
      }
      careAndContent {
        iconId
        title
        sections {
          media
          title
          attributes {
            badgeId
            badgeText
            iconId
            list {
              items
              title
            }
            text
          }
        }
      }
      fabricOrBenefits {
        iconId
        title
        sections ${sectionSchema}
      }
      fitOrIngredients {
        id
        iconId
        title
        sections ${sectionSchema}
      }
      fitOrHowToUse {
        id
        iconId
        title
        sections ${sectionSchema}
      }
      featuresOrIngredients {
        id
        iconId
        title
        sections ${sectionSchema}
      }
    }
  `;
};

export const getProductSummary = () => `{
  productId
  displayName
  unifiedId
  parentCategoryUnifiedId
  pdpUrl
  productUrl
  shareUrl
  whyWeMadeThis
  isFinalSale
  isSoldOut
  isLoyaltyProduct
  isHazmatProduct
  divisionId
  featuredFabric
  fitDetails
  departmentId

  activity
  allAncestorsDisplayName
  allAncestorsRepositoryId
  allAvailableSizes
  bazaarVoiceID
  collections
  colorGroup
  colour
  commonId
  currencyCode
  defaultParentCategory
  defaultSku
  display
  displayCA
  displayNameWithBr
  f5BckimgUrl
  freeReturnShipping
  gender
  genderCategoryTitle
  genderCategoryProductTitle
  hasLinkedProducts
  imageScheme
  isDisplayble
  isProductLocaleMatch
  itemType
  linkedProducts
  listPrice
  locale
  loyaltyTermsAndConditions {
    url
    text
  }
  onSale
  parentCategoryDisplayName
  parentCategoryKeywords
  price
  priceRange
  productActivityIdRepositoryId
  productApplicableSystems
  productBaseUrl
  productCatalogId
  productCategory
  productDefaultSort
  productDisallowAsRecommendation
  productHasOutfitProduct
  productLanguage
  productLastSkuAdditionDateTime
  productMarkDown
  productName
  productNoFollow
  productNoIndex
  productNonReturnable
  productNumberOfImageAssets
  productOnSale
  productSilver
  productSiteMapPdpUrl
  productSizes
  productWhatsNew
  skuOnSale
  skuSkuImages
  skuStyleOrder
  title
  trendingColors
  trendingColorsAll
  type
}`;

export const getCurrency = () => `{
  code
  symbol
}`;

export const getPrice = () => `{
  listPrice
  currency ${getCurrency()}
  onSale
  salePrice
  earlyAccessMarkdownPrice
}`;

export const getColor = () => `{
  code
  name
  swatchUrl
  slug
  simpleRanking
  ituBt709
  ituBt601
  colorHarmonyRank
}`;

export const getMediaLink = () => `{
  type
  url
  posterImageUrl
}`;

export const getSKU = () => `{
  id
  skuUrl
  price ${getPrice()}
  size
  color ${getColor()}
  available
  inseam
  styleId
  styleNumber
}`;

export const getPCMProductStyleInfo = () => `{
  departmentId
  divisionId
}`;

export const getModelIsWearingAttributes = () => `{
  productName
  numberOfAvailableColors
  url
  imageURL
  onSale
  listPrice
  salePrice
}`;

export const getModelInfo = () => `{
  description
  modelIsWearing ${getModelIsWearingAttributes()}
  shopThisLook
}`;

export const getProductCarouselAttributes = ({ fetchPCMMedia = false }) => `{
  color ${getColor()}
  modelInfo ${getModelInfo()}
  imageInfo
  inseam
  mediaInfo ${getMediaLink()}
  ${fetchPCMMedia ? `pcmMediaInfo ${getMediaLink()}` : ""}
}`;

export const getVariants = () => `{
  color ${getColor()}
  skus ${getSKU()}
  imageSet {
    images {
      url
      alt
    }
    modelDescription
  }
}`;

// The `pdpUrl`, `CategoryUnifiedId`, and `productUnifiedId` fields are not duplicates of
// `productSummary`. For an explanation of what they are and why they are here, see this comment on
// PR #7463: https://github.com/Lululemon/ecom-web-app/pull/7463/files#r1253753230
export const getAllLocalePids = () => `{
  CA
  US
  siteId
  pdpUrl
  categoryUnifiedId
  productUnifiedId
}`;

export const getProductVariants = () => `{
  attributeType
  colorCode
  description
  fabric
  fit
  imageUrl
  label
  name
  path
  productId
  type
  value
}`;

export const getProductDetailPageFields = ({
  fetchPCMMedia,
  fetchVariants,
}) => `
  allInseam ${getAllInseam()}
  allLocalePids ${getAllLocalePids()}
  allSize {
    size
    available
  }
  alsoAvailableIn {
    url
    type
  }
  category {
    id
    name
  }
  colorAttributes ${getColorAttributes()}
  colorDriver {
    color
    sizes
  }
  colors ${getColor()}
  highlights {
    highlightIconWeb
    highlightLabel
    visibility
    subText
    abFlag {
      name
      abFlagName
      showIcon
      showSubText
      showHighlight
      visibility
    }
  }
  meta {
    isRedirect
    selfPath
    redirectPath
  }
  ${fetchPCMMedia ? `pcmProductStyleInfo ${getPCMProductStyleInfo()}` : ""}
  pcmProductVideoInfo ${getMediaLink()}
  productAttributes ${getProductAttributes()}
  productCarousel ${getProductCarouselAttributes({
    fetchPCMMedia,
  })}
  productSummary ${getProductSummary()}
  productVariants ${getProductVariants()}
  refinementCrumbs ${getRefinementCrumbs()}
  reviews ${getReviews()}
  sizeDriver {
    size
    colors
  }
  sizeGuide {
    url
    category
  }
  skus ${getSKU()}
  tier
  ${fetchVariants ? `variants ${getVariants()}` : ""}
  whyWeMadeThisAttributes {
    text
    image
  }
`;

export const getProductDetailPage = ({
  fetchPCMMedia = false,
  fetchVariants = false,
  fetchHighlights = false,
  fetchMarkdownConsolidated = false,
}) => {
  const pdpFields = getProductDetailPageFields({
    fetchPCMMedia,
    fetchVariants,
    fetchHighlights,
  });

  return `{
    ${fetchMarkdownConsolidated ? `markdownConsolidated { ${pdpFields} }` : ""}
    ${pdpFields}
  }`;
};
